import { pixiResourceHelper } from './pixiResourceHelper';

export const getResource = (key) => {
  return pixiResourceHelper.get(key);
};
